import onDocumentReady from "shared/onDocumentReady";
import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
import MainGroupRouter from "./MainGroupRouter";
import GroupPage from "./GroupPage";
import GroupPageStory from "./GroupPageStory";
import GroupPageActivity from "./GroupPageActivity";
import GroupPageEvents from "./GroupPageEvents";
import GroupPagePosts from "./GroupPagePosts";
import GroupPageChats from "./GroupPageChats";
import GroupPageSharedListStories from "./sharing_lists/GroupPageSharedListStories";
import GroupPageSharedListWiki from "./sharing_lists/GroupPageSharedListWiki";
import GroupPageSharedListMedia from "./sharing_lists/GroupPageSharedListMedia";
import GroupPageMembers from "./GroupPageMembers";
import GroupPostDetailPage from "./post_detail/GroupPostDetailPage";
import GROUP_DETAIL_PAGE_CHILDREN from './post_detail/postDetailPageChildren';
import GroupPageDefault from "./GroupPageDefault";

const GROUP_PAGE_CHILDREN = [
    {
        name: 'groupDetailPage-default',
        component: GroupPageDefault,
        path: '',
        meta: {name: 'default'}
    },
    {
        name: 'groupDetailPage-story',
        component: GroupPageStory,
        path: 'detail',
        meta: {name: 'story'}
    },
    {
        name: 'groupDetailPage-activity',
        component: GroupPageActivity,
        path: 'activity',
        meta: {name: 'activity'}
    },
    {
        name: 'groupDetailPage-events',
        component: GroupPageEvents,
        path: 'events',
        meta: {name: 'events'}
    },
    {
        name: 'groupDetailPage-posts',
        component: GroupPagePosts,
        path: 'posts',
        meta: {name: 'posts'}
    },
    {
        name: 'groupDetailPage-chats',
        component: GroupPageChats,
        path: 'chats',
        meta: {name: 'chats'}
    },
    {
        name: 'groupDetailPage-shared-stories',
        component: GroupPageSharedListStories,
        path: 'shared-stories',
        meta: {name: 'shared-stories'}
    },
    {
        name: 'groupDetailPage-shared-wiki',
        component: GroupPageSharedListWiki,
        path: 'shared-wikis',
        meta: {name: 'shared-wiki'}
    },
    {
        name: 'groupDetailPage-shared-media',
        component: GroupPageSharedListMedia,
        path: 'shared-media',
        meta: {name: 'shared-media'}
    },
    {
        name: 'groupDetailPage-members',
        component: GroupPageMembers,
        path: 'members',
        meta: {name: 'members'}
    },
];

function initVue() {
    const router = new VueRouter({
        mode: 'history',
        routes: [
            {
                path: "/group/post/:postId(\\d+)/",
                component: GroupPostDetailPage,
                children: GROUP_DETAIL_PAGE_CHILDREN,
                props: true,
                name: 'groupPostDetailPage',
            },
            {
                path: "/group/:groupSlug/",
                component: GroupPage,
                children: GROUP_PAGE_CHILDREN,
                props: true,
                name: 'groupDetailPage',
            },
        ]
    });
    const vm = new Vue({
        el: '#group-page',
        router: router,
        store,
        render(createElement) {
            const {props: attrs} = this;
            return createElement(MainGroupRouter, {attrs});
        },
    });
}

onDocumentReady(initVue);